import React from 'react';
import { createPortal } from 'react-dom';
import ModalStateless from './ModalStateless';

const PortalModal = props => !props.isShowing ? null : createPortal(
  <ModalStateless
    {...props}
    isVisible
    onCloseClicked={props.onCloseClicked}
  />, document.body
);

export default PortalModal;
